import React from 'react'
import {Grid, withStyles} from '@material-ui/core';
import PropTypes from 'prop-types';
import WorkableButton from "components/button/WorkableButton";
import clsx from "clsx";

const style = theme => ({
    root: {},
    item: {
        minWidth: theme.components.popup.buttons.width,
        marginRight: theme.spacing(1)
    },
    before: {
        flexGrow: 1,
        marginLeft: theme.spacing(1)
    }
})

function MultiButton(
    {
        className,
        classes,
        buttons,//created by createButton
        justify = 'flex-end',
        before,
        after,
        afterAfter,
    }) {
    return (
        <Grid container className={className} justifyContent={justify}>
            {!!before && <Grid item className={clsx(classes.item, classes.before)}>{before}</Grid>}
            {!!buttons && buttons.map(
                ({
                     label,
                     onClick,
                     variant,
                     disabled,
                     className,
                     working,
                     Icon
                 }, i) => (<Grid item className={classes.item} key={i}>
                    <WorkableButton
                        fullWidth
                        variant={variant}
                        onClick={onClick}
                        disabled={disabled}
                        className={className}
                        working={working}
                        Icon={Icon}
                    >
                        {label}
                    </WorkableButton>
                </Grid>))}
            {!!after && <Grid item className={classes.item}>{after}</Grid>}
            {!!afterAfter && <Grid item>{afterAfter}</Grid>}
        </Grid>
    )
}

MultiButton.propTypes = {
    className: PropTypes.string,
    classes: PropTypes.any,
}

MultiButton.defaultProps = {}

export const createButton = (label, onClick, variant, disabled = false, className, working = false, Icon) => ({
    label,
    onClick,
    variant,
    disabled,
    className,
    working,
    Icon
});

export default withStyles(style)(MultiButton);